export function footerMobileMenu() {
    const footer = $('.footer-nav-holder >ul');
    const btnFooterNav = `<button class="opener"></button>`;

    $(btnFooterNav).insertBefore(".footer-nav-holder >ul .menu-item-has-children:not(.no-collapse) ul");

    footer.on("click", '.menu-item-has-children .opener', function (e) {
        e.preventDefault();

        if (window.innerWidth < 1024) {
            let $this = $(this);
            let parent = $this.parent();
            if (!parent.hasClass("active")) {
                parent.siblings().removeClass("active");
                footer.find(".menu-item-has-children:not(.no-collapse)  ul").slideUp();
                parent.addClass("active").find("ul").slideDown();
            } else {
                parent.removeClass("active").find("ul").slideUp();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerMobileMenu.js